import React from 'react';

import Main from '../components/main';
import Hauler from '../components/hauler';

import {
  authenticatedRedirect,
  nonAuthenticatedRedirect,
  CreateConfigFn,
} from '../routing/utils';

import { TestErrorBoundary } from '../sentry';

type Keys = `login` | `app` | `hauler` | 'calendar' | 'error-test';

export const createConfig: CreateConfigFn<Keys> = (map) => [
  {
    key: 'error-test',
    roles: {
      and: ['non-authenticated'],
    },
    children: <TestErrorBoundary />,
    path: map['error-test']._,
    exact: true,
    fallback: (roles) => authenticatedRedirect(map)(roles, `/something-wrong`),
  },
  {
    key: 'hauler',
    path: map.hauler._,
    roles: {
      and: ['authenticated', 'hauler'],
    },
    children: <Hauler />,
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
  },
  {
    key: 'app',
    path: map.app._,
    roles: {
      and: ['authenticated'],
    },
    children: <Main />,
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
  },
];
